// import {languages} from '../../helpers/data'; <-- BU SATIRI SİLDİK!
import Item from '../item/Item'
import './Card.css'

const Card = ({ languages }) => { // Veriyi dışarıdan (App.js'den) alıyoruz
    return (
        <div className="cards-area-container">
            <div className="bars">
                <span className="bars-text">maşallah</span>
            </div>
            
            <h1 className="language-title">Languages</h1>
            
            <div className="cards-container">
                {languages.length > 0 ? (
                    languages.map((item, index) => (
                        <Item card={item} key={index}/>
                    ))
                ) : (
                    <p style={{color: "white", textAlign: "center", gridColumn: "1 / -1"}}>Not Found</p>
                )}
            </div>
        </div>
    )
}

export default Card;